var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.25C5 6.65326 5.23705 6.08097 5.65901 5.65901C6.08097 5.23705 6.65326 5 7.25 5H20.75C21.3467 5 21.919 5.23705 22.341 5.65901C22.7629 6.08097 23 6.65326 23 7.25V20.75C23 21.3467 22.7629 21.919 22.341 22.341C21.919 22.7629 21.3467 23 20.75 23H7.25C6.65326 23 6.08097 22.7629 5.65901 22.341C5.23705 21.919 5 21.3467 5 20.75V7.25Z",
    fill: "currentColor"
  })));
};
export default SvgStop;